import Controller from '@ember/controller';
import { service } from '@ember/service';
import type CurrentLocationService from 'garaje/services/current-location';

export default class CommunicationsMessageLogNewController extends Controller {
  @service declare currentLocation: CurrentLocationService;

  // `threat` + `source` come from the emno-fe threat dashboard's "Create incident" deep
  // link (EMNO-83 moved the dashboard into a cross-origin iframe, so params must ride the
  // postMessage → router.transitionTo path). They must be declared here or Ember strips
  // them before the URL bar updates, which breaks RRC's SendMessage `window.location.search`
  // read at mount and the announcement→threat linkage that fires on submit.
  queryParams = ['from', 'threat', 'source'];
  from: string = '';
  threat: string = '';
  source: string = '';

  get locationId(): string {
    return this.currentLocation.location.id;
  }

  get locationName(): string {
    return this.currentLocation.location.name;
  }

  get showBackButton(): boolean {
    return this.from === 'message-log';
  }
}
